<template>
    <div>
        <v-card dark class="pa-4 grey darken-3 ma-4">
            <v-toolbar dark flat dense class="grey darken-3">
                <v-toolbar-title>YOUTV Налаштування</v-toolbar-title>
                <v-btn icon @click="getDataFromApi()" title="Оновити">
                    <v-icon color="grey">mdi-cached</v-icon>
                </v-btn>
            </v-toolbar>
    
            <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
                <v-card-text>
                    <v-flex xs12 lg4 pb-5>
                        <v-switch v-model="f.active" :success="f.active" :error="!f.active" color="primary" hint="Сервіс You TV" persistent-hint :label="(f.active ? 'Вкл.' : 'Вимк.' )">
                        </v-switch>
                    </v-flex>
                    <v-flex xs12 lg6>
                        <validation-provider v-slot="{ errors, valid }" rules="required">
                            <v-textarea rows="2" v-model="f.description" :error-messages="errors" label="Опис"></v-textarea>
                        </validation-provider>
                    </v-flex>
                    <v-container class="fill-height" fluid>
                        <v-flex xs6 lg3>
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <validation-provider v-slot="{ errors, valid }" rules="required">
                                        <v-text-field v-model="f.start" :error-messages="errors" label="Старт" prepend-icon="mdi-calendar-arrow-left" readonly v-on="on"></v-text-field>
                                    </validation-provider>
                                </template>
                                <v-date-picker v-model="f.start" @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs6 lg3>
                            <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <validation-provider v-slot="{ errors, valid }" rules="required">
                                        <v-text-field v-model="f.stop" :error-messages="errors" label="Стоп" prepend-icon="mdi-calendar-arrow-right" readonly v-on="on"></v-text-field>
                                    </validation-provider>
                                </template>
                                <v-date-picker v-model="f.stop" @input="menu = false"></v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-container>
                    <v-flex xs12 lg6>
                        <validation-provider v-slot="{ errors, valid }" rules="required">
                            <v-text-field v-model="f.logo" prepend-icon="mdi-file-image" :error-messages="errors" label="Лого"></v-text-field>
                        </validation-provider>
                    </v-flex>
                    <v-flex xs12 lg6>
                        <validation-provider v-slot="{ errors, valid }" rules="required">
                            <v-text-field v-model="f.route" prepend-icon="mdi-location-enter" :error-messages="errors" label="Роутинг"></v-text-field>
                        </validation-provider>
                    </v-flex>
                    <v-flex xs12 lg6>
                        <validation-provider v-slot="{ errors, valid }" rules="required">
                            <v-text-field v-model="f.color" prepend-icon="mdi-select-color" :error-messages="errors" label="Колiр"></v-text-field>
                        </validation-provider>
                    </v-flex>
                    <v-flex xs12 lg6>
                        <v-subheader class="mt-6">Статистика продажів кодів</v-subheader>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" width="25%">Пакет</th>
                                        <th class="text-left" width="25%">Доступно</th>
                                        <th class="text-left" width="25%">Продано</th>
                                        <th class="text-left" width="25%">Скасовано</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in cerviceCodes" :key="i">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.available }}</td>
                                        <td>{{ item.sold_out }}</td>
                                        <td>{{ item.canceled }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left" width="25%"></th>
                                        <th class="text-left" width="25%"> </th>
                                        <th class="text-left" width="25%">
                                            <v-btn small text outlined @click="openExport = true">
                                                Експорт продажів <v-icon class="pl-3">mdi-export</v-icon>
                                            </v-btn>
    
                                        </th>
                                        <th class="text-left" width="25%">
                                            <v-btn small text outlined @click="showCanceled()">Переглянути</v-btn>
                                        </th>
                                    </tr>
                                </thead>
                            </template>
                        </v-simple-table>
                    </v-flex>
                    <v-flex xs12 lg6 class="mt-4 px-4 grey darken-2">
                        <v-subheader>Перевірка продажу</v-subheader>
                        <v-text-field :success="phone.length == 17" persistent-hint hint="Введiть телeфон користувача" prepend-icon="mdi-phone" name="phone" label="Телефон" placeholder="+38(000) 000 - 0000" v-mask="maskTel" v-model="phone"></v-text-field>
                        <v-btn color="red" :disabled="phone.length != 17" text @click="getSoldOut()">Шукати</v-btn>
                    </v-flex>
    
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="grey" @click="goBack()">
                        <v-icon color="grey">mdi-keyboard-return</v-icon> Повернутись
                    </v-btn>
                    <v-btn color="cardheader" text @click="submitForm()">Зберегти</v-btn>
                </v-card-actions>
            </ValidationObserver>
        </v-card>
    
        <v-dialog v-model="openExport" scrollable max-width="600">
            <v-card>
                <v-system-bar>
                    <v-spacer></v-spacer>
                    <v-icon @click="openExport = false">mdi-close</v-icon>
                </v-system-bar>
                <v-card-title class="headline">В Excel</v-card-title>
                <v-card-text>
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="exportFrom" label="З дати" prepend-icon="mdi-calendar-arrow-left" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="exportFrom" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                    <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="exportTo" label="По дату" prepend-icon="mdi-calendar-arrow-right" readonly v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="exportTo" @input="menu4 = false"></v-date-picker>
                    </v-menu>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="orange" dark @click="exportData()">Експорт</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <v-dialog v-model="openStats" scrollable max-width="80%">
            <v-card>
                <v-system-bar>
                    <v-spacer></v-spacer>
                    <v-icon @click="openStats = false">mdi-close</v-icon>
                </v-system-bar>
                <v-system-bar color="white" v-if="soldOut">
                    <v-spacer></v-spacer>
                    <v-btn small text @click="exportData(search)" class="mt-5 primary--text">
                        Експорт продажів <v-icon class="pl-3 primary--text">mdi-export</v-icon>
                    </v-btn>
                </v-system-bar>
                <v-card-title class="headline">{{statsHeader}}
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-account-search" label="Пошук" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="list" :footer-props="footerProps" :search="search" class="elevation-1" @click:row="openCard($event.member_id)">
                    <template v-slot:item.permissions="{ item }">
                        <span v-html="item.permissions"></span>
                    </template>
                    <template v-slot:no-data>
                        ...
                    </template>
                </v-data-table>
    
            </v-card>
        </v-dialog>
    </div>
    </template>
    
    <script>
    import {
        ValidationObserver,
        ValidationProvider
    } from "vee-validate"
    
    import {
        mapActions
    } from 'vuex'
    
    import {
        mask
    } from "vue-the-mask"
    
    export default {
        components: {
            ValidationProvider,
            ValidationObserver
        },
        directives: {
            mask
        },
        data() {
            return {
                f: {},
                menu: false,
                menu2: false,
                menu3: false,
                menu4: false,
                openExport: false,
                openStats: false,
                exportFrom: null,
                exportTo: null,
                maskTel: '+38(###) ###-####',
                phone: '',
                statsHeader: '',
                search: '',
                list: [],
                exportLink: false,
                soldOut: false,
                footerProps: {
                    'items-per-page-options': [10, 20],
                    'items-per-page-text': 'на стор.'
                },
                headers: [{
                        text: 'Документ Тайфун',
                        align: 'left',
                        sortable: true,
                        value: 'typhoon_doc',
                        selected: false,
                        width: '5%',
                    },
                    {
                        text: 'Контрагент',
                        align: 'left',
                        sortable: true,
                        value: 'contractor',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'TT',
                        align: 'left',
                        sortable: true,
                        value: 'shop',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Моб.телефон',
                        align: 'left',
                        sortable: true,
                        value: 'phone',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Дата',
                        align: 'left',
                        sortable: true,
                        value: 'date',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Код You TV',
                        align: 'left',
                        sortable: true,
                        value: 'code',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Назва послуги',
                        align: 'left',
                        sortable: true,
                        value: 'service_name',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Вартість послуги',
                        align: 'left',
                        sortable: true,
                        value: 'price',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Статус',
                        align: 'left',
                        sortable: true,
                        value: 'status_name',
                        selected: false,
                        width: '10%',
                    },
                    {
                        text: 'Дата статусу',
                        align: 'left',
                        sortable: true,
                        value: 'status_date',
                        selected: false,
                        width: '10%',
                    },
                ]
            }
        },
        methods: {
            ...mapActions(['setSnackbar', 'touch', 'getYoutvServiceData', 'updateYoutvServiceData', 'getYoutvServiceCodeStat', 'getYoutvStatExport', 'getYoutvStat', 'createXlsx']),
            getDataFromApi() {
                this.touch()
                    .then(
                        () => {
                            this.getYoutvServiceData()
                                .then(data => {
                                    this.f = data || {}
                                    this.f.active = (this.f.active == 1 ? true : false)
                                })
                            this.getYoutvServiceCodeStat()
                        }
                    )
                    .catch(
                        error => this.setSnackbar(['error', error])
    
                    )
            },
            goBack() {
                window.history.state ? this.$router.go(-1) : this.$router.push('/adminpanel')
            },
            async submitForm() {
                const isValid = await this.$refs.observer.validate();
                if (!isValid) {
                    this.setSnackbar(['error', 'Заповнiть усi необхiднi поля'])
                } else {
                    this.updateYoutvServiceData(this.f)
                        .then(() => {
                            this.setSnackbar(['info', 'Успiшно збережено'])
                        })
                        .catch(error => {
                            this.setSnackbar(['error', error])
                        })
                }
            },
            exportData(phone) {
                if(phone) {
                    this.exportTo = ''
                    this.exportFrom = ''
                } else {
                    this.search = ''
                }
                this.getYoutvStatExport({
                        status: [2],
                        dateTo: this.exportTo,
                        dateFrom: this.exportFrom,
                        phone
                    })
                    .then(data => {
                        this.createXlsx(data)
                            .then(
                                () => {
                                    this.openExport = false
                                    window.open(process.env.NODE_ENV === 'production' ? '/api/xlsx/file/Report.xlsx' : 'http://dev.extraservices.com.ua:3003/api/xlsx/file/Report.xlsx')
                                }
                            )
                    })
                    .catch(error => this.setSnackbar(['error', error]))
            },
            showCanceled() {
                this.search = ''
                this.getStats([3, 4], 'Cкасованi коди')
            },
            getStats(status, text) {
                this.statsHeader = text
                this.openStats = true
                this.getYoutvStat({
                        status: status
                    })
                    .then(data => {
                        this.list = data || []
                    })
                    .catch(error => this.setSnackbar(['error', error]))
            },
            getSoldOut() {
                this.getStats([2], 'Проданi коди')
                this.search = this.phone.replace(/\D/g, '')
                this.soldOut = true
            }
        },
        created() {
            this.getDataFromApi()
        },
        computed: {
            cerviceCodes() {
                return this.$store.state.adminpanel.youtvCodeStat
            }
        },
        watch: {
            openStats(v) {
                if (!v) {
                    this.soldOut = false
                }
            }
        }
    }
    </script>
    
    <style>
    </style>
    